import {
  ModalIllioLogo,
  ModalCloseButton,
  WhatIfResultsPage,
} from "@iliotech/component-library";
import {
  useAuth,
  usePortfolio,
  usePortfolioComparison,
} from "@iliotech/data-wire";
import { useNavigate, useParams } from "react-router";
import React from "react";

export function WhatIfSelfResults() {
  const { portfolioId, basePortfolioId, otherPortfolioId } = useParams();
  const navigate = useNavigate();
  const { illioSelectedAccount } = useAuth();
  const portfolio = usePortfolio(basePortfolioId!);
  const { data, isLoading, isFetched } = usePortfolioComparison(
    illioSelectedAccount?.externalAccountId!,
    basePortfolioId!,
    otherPortfolioId!,
    portfolio?.data?.data?.inceptionDate!
  );

  const actualScenarioData = data?.data;

  const loading = isLoading || !isFetched;

  const onCloseWithNoSave = () => {
    navigate("/portfolio/" + portfolioId! + "/what-if");
  };

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        background: "var(--background-color)",
      }}
    >
      <ModalIllioLogo />
      <ModalCloseButton
        text="Close"
        style={{ zIndex: 9999 }}
        onPress={onCloseWithNoSave}
      />
      <WhatIfResultsPage
        skipCloseModal
        onCloseWithNoSave={onCloseWithNoSave}
        title={undefined}
        onDelete={onCloseWithNoSave}
        onNotSave={onCloseWithNoSave}
        onSave={onCloseWithNoSave}
        basePortfolioId={basePortfolioId!}
        virtualId={otherPortfolioId!}
        isLoading={loading}
        scenarioData={actualScenarioData!}
      />
    </div>
  );
}

export default WhatIfSelfResults;
